import { render } from "./JoinReporter.vue?vue&type=template&id=35270709"
import script from "./JoinReporter.vue?vue&type=script&lang=js"
export * from "./JoinReporter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__